<template>
<div class="smsAuth">
  <div class="row" v-if="!codeInput">
    <div class="col-md-12 col-sm-12 col-12 input-line">
      <MaskInput
          ref="phone"
          class="phone"
          mask="+38 (0##) ###-##-##"
          v-model="phone"
          type="text"
          @change.native="phoneEror=false"
          :masked="true"
          placeholder="+38 (0__) ___-__-__"
      />
      <div class="error-info" v-if="phoneEror">{{params.messages.phoneError}}</div>
      <div class="error-info" v-if="informText" v-html="informText"></div>
    </div>
    <div class="col-md-12 col-sm-12 col-12 input-line">
      <span class="def-bt light" @click="sendSms()">{{params.messages.sendBtn}}</span>
    </div>
  </div>
  <form class="row" @submit.prevent="false" v-else>
    <div class="col-md-12 col-sm-12 col-12 input-line">
      <input
          type="text"
          @click="codeEror=false"
          v-model="code"
          id="single-factor-code-text-field"
          :placeholder="params.messages.code"
          autocomplete="one-time-code"
          name="one-time-code"
      />
      <div class="error-info" v-if="informText" v-html="informText"></div>
    </div>
    <div class="col-md-12 col-sm-12 col-12 input-line">
      <span class="def-bt light" @click="testSms()">{{params.messages.authBtn}}</span>
    </div>
    <div class="col-md-12 col-sm-12 col-12 input-line">
      <div v-if="resendAfter>0" class="phoneSend">
        {{params.messages.resendAfter}}: {{smsResendTime}}
      </div>
      <div v-else class="phoneSend">
        <span @click="sendSms()" class="smollLink def-bt white">{{params.messages.resendBtn}}</span>
        <span @click="codeInput=false" class="smollLink def-bt white">{{params.messages.setNumberBtn}}</span>
      </div>
    </div>
  </form>
</div>
</template>

<script>
import { MaskInput } from 'vue-3-mask';

export default {
  name: "smsAuth",
  selector: '.smsAuth',
  components: {MaskInput},
  props:{params: Object},
  data() {
    return {
      phone:"",
      phoneEror:false,
      codeEror:false,
      informText:'',
      codeInput:false,
      resendAfter:10,
      code:"",
    }
  },
  methods:{
    async sendSms() {
      if(!this.phone) {
        this.phoneEror = true;
      } else {
        let formData = new FormData();
        for(let index in this.params.fields) {
          formData.append(this.params.fields[index].name,this.params.fields[index].value);
        }
        formData.append("phone",this.phone);

        await axios.post(this.params.sendAjax, formData).then((response) => {
          if (response.data?.data?.message) {
            this.informText = response.data.data.message;
          } else {
            this.informText = '';
            if (response.data.status == "success") {
              this.codeInput = true;
              let now = new Date();
              this.resendAfter = Math.round(response.data.data['nextSMS'] - (now.getTime() / 1000));
            } else {
              this.informText = response.data.message;
            }
          }
        })
      }
    },
    async testSms() {
      if(!this.code) {
        this.codeEror = true;
      } else {
        let formData = new FormData();
        let checkout = false;
        for(let index in this.params.fields) {
          if (this.params.fields[index].name == "checkout" && this.params.fields[index].value == true){
            checkout = true;
          }
          formData.append(this.params.fields[index].name,this.params.fields[index].value);
        }
        formData.append("func",'confirmAuthCode');
        formData.append("phone",this.phone);
        formData.append("code",this.code);
        await axios.post(this.params.sendAjax, formData).then((response) => {
          if(response.data.data['status']) {
            if (checkout){
              this.$emit('auth');
            } else {
              location.href = window.authBackUrl?window.authBackUrl:this.params.back?this.params.back:'/';
            }
          } else {
            this.codeEror = true;
            this.informText = response.data.data.message;
          }

        })
      }
    }
  },
  computed: {
    smsResendTime() {
      let t = "";
      if(this.resendAfter<60) {
        t = this.resendAfter+' '+this.params.messages.timeText.s;
      } else if(this.resendAfter<3600) {
        t = Math.floor(this.resendAfter / 60) + ' ' + this.params.messages.timeText.m;
        let ost = Math.floor(this.resendAfter % 60);
        if (ost > 0) {
          t += " " + ost + ' ' + this.params.messages.timeText.s;
        }
      } else {
        t = Math.floor(this.resendAfter / 3600) + ' ' + this.params.messages.timeText.h;
      }
      if(this.resendAfter>0) {
        setTimeout(()=>{this.resendAfter--;},1000);
      }
      return t;
    }
  },
}
</script>

<style lang="scss" scoped>
  .smsAuth {
      padding-top: 30px;
    .input-line {
      margin-bottom: 15px;
    }
    .smollLink {
      margin-bottom: 15px;
    }
    .phone {
      font-size: 16px;
    }
    @include point-md {
      .phone {
        font-size: rem(14);
      }
    }
  }

</style>